import { cdmPartner } from './cdm'
import type { PartnerConfig } from './types'

export type { PartnerConfig, PartnerPalette, PartnerSearchDefaults, PartnerVenue } from './types'
export { cdmPartner }

export const PARTNERS: readonly PartnerConfig[] = [cdmPartner]

const normaliseHost = (host: string | null | undefined): string =>
  (host || '').trim().toLowerCase().split(':')[0]

export const resolvePartnerByHost = (
  host: string | null | undefined
): PartnerConfig | null => {
  const normalised = normaliseHost(host)
  if (!normalised) return null
  return PARTNERS.find((partner) => partner.host === normalised) || null
}

export const getPartnerBySlug = (slug: string): PartnerConfig | null =>
  PARTNERS.find((partner) => partner.slug === slug) || null
